import type { ReportFilterSelectOption } from '../shared/report-filter-select-option.model';

/** Task pane element id; must match reporting target filter field specs. */
export const REPORT_RECORD_COUNT_ELEMENT_ID = 'filter-record-count';

/** Wrapper row in `taskpane.html`; Record Count renders here (above Record type). */
export const REPORT_RECORD_COUNT_FIELD_WRAP_ID = 'report-record-count-field';

/** Default `<select>` value and numeric fallback when DOM value is missing or invalid. */
export const REPORT_RECORD_COUNT_DEFAULT_VALUE = '25000';

export const REPORT_RECORD_COUNT_DEFAULT_NUM = 25_000;

/** Allowed `recordCount` values for Get-Agreements pagination. */
export const REPORT_RECORD_COUNT_ALLOWED_NUMBERS: readonly number[] = [
    5_000, 10_000, 25_000, 50_000, 100_000,
];

export const REPORT_RECORD_COUNT_SELECT_OPTIONS: readonly ReportFilterSelectOption[] =
    REPORT_RECORD_COUNT_ALLOWED_NUMBERS.map((n) => ({
        value: String(n),
        label: String(n),
    }));

/** Normalizes task-pane / test `recordCount` to an allowed value. */
export function resolveReportRecordCount(value: number | undefined): number {
    if (typeof value === 'number' && REPORT_RECORD_COUNT_ALLOWED_NUMBERS.includes(value)) {
        return value;
    }
    return REPORT_RECORD_COUNT_DEFAULT_NUM;
}
